module.exports = __webpack_public_path__ + "assets/img/btn-detail-b355eec6.png";